import { render, staticRenderFns } from "./changePwdDialog.vue?vue&type=template&id=acbf2a4c&scoped=true&"
import script from "./changePwdDialog.vue?vue&type=script&lang=js&"
export * from "./changePwdDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbf2a4c",
  null
  
)

export default component.exports